import React, { createContext, useReducer } from "react";

const initialState = {
    payablesData: {
        lessThan15Days: { loading: true, payables: [] },
        lessThan30Days: { loading: true, payables: [] },
        moreThan30days: { loading: true, payables: [] },
    },
    inFlight: false,
};

const payablesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_START":
            return { ...state, inFlight: true };

        case "REQUEST_END":
            return { ...state, inFlight: false };

        case "FETCH_PAYABLES_LESS_THAN_15":
            return {
                ...state,
                payablesData: {
                    ...state.payablesData,
                    lessThan15Days: {
                        loading: false,
                        payables: action.payload.payables,
                    },
                },
            };

        case "FETCH_PAYABLES_LESS_THAN_30":
            return {
                ...state,
                payablesData: {
                    ...state.payablesData,
                    lessThan30Days: {
                        loading: false,
                        payables: action.payload.payables,
                    },
                },
            };

        case "FETCH_PAYABLES_MORE_THAN_30":
            return {
                ...state,
                payablesData: {
                    ...state.payablesData,
                    moreThan30days: {
                        loading: false,
                        payables: action.payload.payables,
                    },
                },
            };

        case "CREATE_PAYABLE":
            const { new_payable } = action.payload;
            const newState = { ...state, inFlight: false };

            const days = new_payable.info.remaining_days;

            if (days < 15) {
                newState.payablesData.lessThan15Days.payables.push(new_payable);
            } else if (days < 30) {
                newState.payablesData.lessThan30Days.payables.push(new_payable);
            } else {
                newState.payablesData.moreThan30days.payables.push(new_payable);
            }
            return newState;

        case "DELETE_PAYABLE":
            const { payableId, duration } = action.payload;

            const new_state = { ...state, inFlight: false };
            new_state.payablesData[duration].payables = new_state.payablesData[
                duration
            ].payables.filter((payable) => payable.id !== payableId);

            return new_state;

        case "UPDATE_PAYABLE":
            const { payable_id, data, duration: d } = action.payload;

            const updatedState = { ...state, inFlight: false };

            updatedState.payablesData[d].payables = updatedState.payablesData[
                d
            ].payables.filter((payable) => payable.id !== payable_id);

            const rem_days = data.info.remaining_days;

            if (rem_days < 15) {
                updatedState.payablesData.lessThan15Days.payables.push(data);
            } else if (rem_days < 30) {
                updatedState.payablesData.lessThan30Days.payables.push(data);
            } else {
                updatedState.payablesData.moreThan30days.payables.push(data);
            }

            return updatedState;

        case "CREATION_FAILED":
            return { ...state, inFlight: false };

        default:
            return state;
    }
};

const useThunkReducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const enhancedDispatch = React.useCallback(
        (action) => {

            if (typeof action === "function") {
                action(dispatch);
            } else {
                dispatch(action);
            }
        },
        [dispatch]
    );

    return [state, enhancedDispatch];
};

export const PayablesContext = createContext();

export const PayablesProvider = ({ children }) => {
    const [state, dispatch] = useThunkReducer(payablesReducer, initialState);

    return (
        <PayablesContext.Provider value={{ state, dispatch }}>
            {children}
        </PayablesContext.Provider>
    );
};
